<template>
    <div>
        <ModalAssinatura v-model="abreModalAssinatura" :src="urlAssinatura" :titulo="'Assinar Documento'" @fechouModal="filtrarDocumentos()" />

        <h1 class="text-center">Assinatura Eletrônica de Documentos</h1>

        <h4 class="d-flex mx-2">Período</h4>

        <div class="col-6 mx-2 d-flex align-items-center">
            <DateRangePicker :dataInicio="dataInicio" :dataFim="dataFim" :validado="datasValidadas" @update:dataInicio="dataInicio = $event" @update:dataFim="dataFim = $event" />
            <b-button
                variant="primary"
                @click="filtrarDocumentos()"
                class="mx-3 mt-3 d-flex justify-content-center align-items-center"
                style="height: 33px;"
            >
                <i class="mdi mdi-filter-outline font-size-16 align-middle me-1"></i>
                Filtrar
            </b-button>
        </div>

        <div v-if="this.retornouBusca"  class="d-flex justify-content-evenly">
            <div id="pendente" class="col mx-2">
                <KanbanDocumentos titulo="Assinaturas pendentes" classeCor="warning" :desabilitado="true" :listaKanban="pendentes" :showCursor="true" @clickKanban="getUrlAssinatura"/>
            </div>
            <div id="assinado" class="col mx-2">
                <KanbanDocumentos titulo="Assinados" classeCor="success" :desabilitado="true" :listaKanban="assinados" :showCursor="false"/>
            </div>
            <div id="cancelado" class="col mx-2">
                <KanbanDocumentos titulo="Cancelados" classeCor="danger" :desabilitado="true" :listaKanban="cancelados" :showCursor="false"/>
            </div>
        </div>

        <div v-if="this.carregando" id="loader" class="position-fixed top-50 start-50 translate-middle d-flex justify-content-center align-items-center">
            <b-spinner variant="primary"></b-spinner>
        </div>
    </div>
</template>

<script>
    import KanbanDocumentos from "@/components/assinaturaEletronica/kanbanDocumentos";
    import ModalAssinatura  from "@/components/assinaturaEletronica/modalAssinatura";
    import DateRangePicker  from "@/components/formulario/date-range-picker-input";

    export default{
        components: {
            KanbanDocumentos,
            ModalAssinatura,
            DateRangePicker
        },
        data() {
            return {
                pendentes          : [],
                assinados          : [],
                cancelados         : [],
                dataInicio         : this.formatarData(new Date(new Date().setMonth(new Date().getMonth() - 1))),
                dataFim            : this.formatarData(new Date()), 
                carregando         : false,
                retornouBusca      : false,
                datasValidadas     : true,
                abreModalAssinatura: false,
                urlAssinatura      : ""
            }
        },
        methods: {
            filtrarDocumentos(){
                this.pendentes     = [];
                this.assinados     = [];
                this.cancelados    = [];
                this.retornouBusca = false;

                const [mesInicio, anoInicio] = this.dataInicio == null ? [null, null] : this.dataInicio.split('/');
                const [mesFim, anoFim]       = this.dataFim    == null ? [null, null] : this.dataFim.split('/');
                const dataInicioDate         = this.dataInicio == null ? null         : new Date(anoInicio, mesInicio - 1);
                const dataFimDate            = this.dataFim    == null ? null         : new Date(anoFim, mesFim - 1);
                
                if (dataInicioDate > dataFimDate && dataFimDate !== null) {
                    this.datasValidadas = false;
                    this.$tools.alerta("A data de início não pode ser maior que a data de fim.", "error");

                    return;
                }

                this.datasValidadas = true;
                this.carregando     = true;

                const params = {
                    sq_cargo   : this.retornaCargo(),
                    data_inicio: this.dataInicio,
                    data_fim   : this.dataFim
                }

                this.$http
                .get("api/assinaturas/assinaturaEletronicaConselho", {params})
                .then((response) => {
                    const documentos = response.data.documentos;

                    if (response.data.documentos.length === 0){
                        this.$tools.alerta("Não foi encontrado documentos com o período informado.", "error");

                        return;
                    }
                    
                    this.pendentes     = documentos.filter(documento => documento.st_upload == 1);
                    this.assinados     = documentos.filter(documento => documento.st_upload == 2);
                    this.cancelados    = documentos.filter(documento => documento.st_upload == 3);
                    this.retornouBusca = true;

                    this.verificarAssinaturaConselho();
                })
                .catch((error) => {
                    this.$tools.alerta("Ocorreu um erro ao buscar documentos, por favor tente novamente. " + error, "error");
                })
                .finally(() => {
                    this.carregando = false;
                });
            },
            formatarData(data) {
                const [mes, ano] = [                 
                    String(data.getMonth() + 1).padStart(2, '0'),
                    String(data.getFullYear()),
                ];

                return `${mes}/${ano}`;
            },
            getUrlAssinatura(documento){
                this.carregando = true;

                this.$http
                .get(`api/assinaturas/getUrlAssinatura/${documento.sq_upload}`)
                .then((response) => {
                    if(response.data.IsValid){

                        this.urlAssinatura       = response.data.Data;
                        this.abreModalAssinatura = true;

                    }else{
                        this.$tools.alerta(response.data.Message, "error");
                    }
                })
                .catch((error) => {
                    this.$tools.alerta(error, "error");
                })
                .finally(() => {
                    this.carregando = false;
                });
            },
            verificarAssinaturaConselho(){
                this.$http
                .get(`/api/assinaturas/verificarPendenciaConselho/${this.retornaCargo()}`)
                .then((response) => {

                    if(response.data.temAssinaturaPendente === true){
                        this.$store.commit("VALIDA_ASSINATURA_CONSELHO", false);
                    }else{
                        this.$store.commit("VALIDA_ASSINATURA_CONSELHO", true);
                    }

                    this.$store.commit('SET_ASSINATURAS_PENDENTES_CONSELHO', response.data.quantidade);
                })
                .catch((error) => {
                    this.$tools.alerta(error, "error");
                    this.$store.commit("VALIDA_ASSINATURA_CONSELHO", true);
                });
            },
            retornaCargo() {
                const cargos = this.$store.state.me?.tp_Pessoa?.sq_cargo;

                if (Array.isArray(cargos) && cargos.length > 0) {
                    return cargos.find(cargo => cargo == 30) || cargos[0];
                }
                
                return null;
            }
        }
    }
</script>

<style>
    #pendente, #assinado, #cancelado{
        height: calc(100vh - 385px);
    }

    #loader{
        z-index   : 9999; 
        width     : 100vw; 
        height    : 100vh; 
        background: rgba(255,255,255,0.5);
    }
</style>